import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import WellnessSurvey from "@/pages/WellnessSurvey";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/wellness-survey")({
  head: () => seoHead("/wellness-survey"),
  component: () => (
    <AuthGate><WellnessSurvey /></AuthGate>
  ),
});
